var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.65276 10.3456L1.37003 10.1897C7.89047 8.77219 13.7348 5.1788 17.9425 0L18.5727 0.720234C22.72 5.45992 28.2169 8.8186 34.3268 10.3461C34.6887 10.4365 34.9425 10.7617 34.9425 11.1346V13.2719C34.9425 19.1273 32.3765 24.6887 27.9215 28.4886L17.9425 37L7.21038 27.8461C3.19545 24.4216 0.696629 19.5491 0.258397 14.2903L0.00289465 11.2243C-0.0316444 10.8098 0.246347 10.434 0.65276 10.3456ZM10.617 24.5542C11.0899 21.0858 14.0523 18.5 17.5528 18.5H18.3323C21.8328 18.5 24.7951 21.0858 25.2681 24.5542L25.3234 24.9595C25.6509 27.3613 23.784 29.5 21.3601 29.5H14.525C12.1011 29.5 10.2342 27.3613 10.5617 24.9595L10.617 24.5542ZM17.9425 17.5C20.1517 17.5 21.9425 15.7091 21.9425 13.5C21.9425 11.2909 20.1517 9.5 17.9425 9.5C15.7334 9.5 13.9425 11.2909 13.9425 13.5C13.9425 15.7091 15.7334 17.5 17.9425 17.5Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.00f042a977f9d26f4b1ccea1e0a3e2c3.svg";
export { ForwardRef as ReactComponent };